import OrganizationNoteDetailsWrapper from "@/pages/organisaties/notities/OrganizationNoteDetailsWrapper"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/organisaties/$organizationId/notities/$noteThreadId/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "organizations"),
})

function RouteComponent() {
  const { organizationId, noteThreadId } = useParams({
    from: "/beheer/organisaties/$organizationId/notities/$noteThreadId/",
  })

  return (
    <OrganizationNoteDetailsWrapper
      organizationId={Number(organizationId)}
      noteThreadId={Number(noteThreadId)}
    />
  )
}
